import { useContext, useState } from 'react'
import FetchContext from '../../context/fetch/FetchContext'
import AnnouncementsContext from '../../context/announcements/AnnouncementsContext'
import { PopupWorkingSet } from '../../units/announcements/PopupWorkingSet'

const PREVIEW_CLAIMANT = 'preview'

export default function useAnnouncementPreview() {
    const fetcher = useContext(FetchContext)
    const { popupOwnership } = useContext(AnnouncementsContext)

    const [preview, setPreview] = useState(null)

    const openPreview = async (documentId) => {
        if (!popupOwnership.claim(PREVIEW_CLAIMANT, {
            replace: true,
            onDisplaced: () => setPreview(null),
        })) {
            return
        }

        const announcement = await fetcher.fetchAnnouncementForPreview(documentId)
        setPreview(new PopupWorkingSet([announcement]))
    }

    const closePreview = () => {
        popupOwnership.release(PREVIEW_CLAIMANT)
        setPreview(null)
    }

    return {
        preview,
        openPreview,
        closePreview,
    }
}
